(function() {
  "use strict";

  function ModalBlackFridayCtrl($uibModalInstance, Perfil) {
    var vm = this;
    vm.close = function() {
      $uibModalInstance.close();
    };

    vm.stopBlackFridayModal = function(e){
      localStorage.setItem('ls.mdlBF', e);
    };
  }

  angular
    .module("mandaeApp")
    .controller("ModalBlackFridayCtrl", ModalBlackFridayCtrl);
})();
